export const version = "providers/5.7.0";
//# sourceMappingURL=_version.js.map